export default class BandharuService {

    searchContainer(container: string): Promise<any> {
        return fetch(`${process.env.VUE_APP_API_URL}web_dashboard/search_web_containers?query=${container}`).then(res => res.json());
    }

    getShippingAgents() {
        return fetch(`${process.env.VUE_APP_API_URL}web_dashboard/web_ship_agents`).then(res => res.json());
    }

    getClearingAgents() {
        return fetch(`${process.env.VUE_APP_API_URL}web_dashboard/web_clearing_agents`).then(res => res.json());
    }

    getOverallStatistics() {
        return fetch(`${process.env.VUE_APP_API_URL}web_dashboard/web_overall_status`).then(res => res.json());
    }

    getShipsAtPort() {
        return fetch(`${process.env.VUE_APP_API_URL}web_dashboard/web_ships_at_port`).then(res => res.json());
    }

    getEta() {
        return fetch(`${process.env.VUE_APP_API_URL}web_dashboard/web_eta`).then(res => res.json());
    }

    getDailyExpress() {
        return fetch(`${process.env.VUE_APP_API_URL}web_dashboard/daily_express`).then(res => res.json());
    }


}
